<!--suppress ALL -->
<template>
  <div>
    <div
      :class="['alarm', isWaring ? 'warAlarm' : '']"
      ref="alarm"
      @click="showFire"
      v-show="$store.state.user.userInfo.natureId == 1 || $store.state.user.userInfo.natureId == 3 || $store.state.user.userInfo.natureId == 4 || bimStaus"
    >
      <div class="hj-notice-zhi animated rollIn" v-show="!isWaring && $route.name == 'Home'">
        <img src="@/assets/img/Popup1.png" :draggable="true" v-show="!bimStaus" />

        <el-button type="danger" v-show="bimStaus" size="mini" @click.stop @click="$store.commit('bimchange')">关闭bim</el-button>
      </div>
      <div class="hg-notice-new hg-notice-new-img flex" v-show="isWaring && $route.name == 'Home'">
        <div class="hg-notice-icon ml20 mt10">
          <div class="icon-cont">
            !
          </div>
        </div>
        <div class="hg-notice-cont mt10 ml10">
          <!-- 类型名称 -->
          <div class="flex hg-notice-item  ">
            <div>
              <span class="" v-if="!($store.state.user.userInfo.natureId == 4)">{{ info.evenClass }}</span>
              <span class="" v-else>{{ '火警上报' }}</span>

              <span v-if="!($store.state.user.userInfo.natureId == 4)" class="ml10" :title="info.company">
                {{ info.company }}
                <!-- <a class=" bim" v-if="info.isbim && info.isbim == 1" @click.stop @click="bimchange(info)">{{ bimStaus ? "关闭bim" : "展示bim" }}</a> -->
              </span>
              <span v-else class="hj-notice-f12" :title="info.company">{{ info.c_name }} </span>
            </div>
          </div>
          <!-- 日期 -->
          <div class="hg-notice-item mt10">
            <span>{{ info.nowtime }}</span>
          </div>
          <!--描述  -->
          <div class="hg-notice-item mt10">
            <div class="" v-if="!($store.state.user.userInfo.natureId == 4)" :title="info.msgDescribe">警情描述：{{ info.msgDescribe }}</div>
            <div class="" v-if="$store.state.user.userInfo.natureId == 4" :title="info.msgDescribe">警情描述：{{ info.remark }}</div>
            <!-- <div class="mt10 cursor" @click.stop="deviceDetail">
            查看详情
          </div> -->
          </div>
        </div>
        <!--  
        <div class="hj-notice-f">
          <div class="hj-notice-f1">
            <span class="hj-notice-f11" v-if="  !($store.state.user.userInfo.natureId ==4)">{{
              info.evenClass
            }}</span>
            <span class="hj-notice-f11" v-else>{{ "火警上报" }}</span>

            <span
              v-if="  !($store.state.user.userInfo.natureId ==4)"
              class="hj-notice-f12"
              :title="info.company"
              >{{ info.company }}
              <a
                class="hj-notice-f12 bim"
                v-if="info.isbim && info.isbim == 1"
                @click.stop
                @click="bimchange(info)"
                >{{ bimStaus ? "关闭bim" : "展示bim" }}</a
              >
            </span>
            <span v-else class="hj-notice-f12" :title="info.company"
              >{{ info.c_name }}
            </span>
          </div>
          <div
            class="hj-notice-f2"
            v-if="!($store.state.user.userInfo.natureId ==4)"
            :title="info.msgDescribe"
          >
            警情描述：{{ info.msgDescribe }}
          </div>
          <div
            class="hj-notice-f2"
            v-if="$store.state.user.userInfo.natureId ==4"
            :title="info.msgDescribe"
          >
            警情描述：{{ info.remark }}
          </div>
          <div class="hj-notice-f3" :title="info.nowtime">
            {{ info.nowtime }}
          </div>
        </div> -->
      </div>
    </div>
    <!-- 联网单位实时列表 -->
    <el-dialog :visible.sync="showbjList" width="100%" :show-close="false">
      <div slot="title" class="dialog-header">
        <div class="d-title flex1" style="position: relative">
          <i class="icon-tr-Real-time-alarm" style="padding-right: 5px"></i><span style="color: white">实时报警信息</span>
          <div class="btn" @click="closeAlarm()" style="position: absolute; right: 0; top: -4px" v-if="isWaring">
            <span>关闭此次警报</span>
          </div>
          <div
            class="btn"
            @click="setMessage()"
            v-if="$store.state.user.userInfo.natureId == 2"
            :style="{ position: ' absolute', right: isWaring ? '150px' : '0', top: '-4px', color: 'red' }"
          >
            <span>预案灭火启动</span>
          </div>
        </div>
        <div class="d-right align-center">
          <!-- <div class="btn">
                           <span>选择报警：</span>
                            <el-select size="mini" style="" >
                             <el-option key="火警" value="火警">火警</el-option>
                              <el-option key="火警" value="火警">监管</el-option>
                              <el-option key="火警" value="火警">复位</el-option>  
                            </el-select>
                       </div> -->
          <div>
            <el-dropdown v-if="!($store.state.user.userInfo.natureId == 4)">
              <span class="btn">
                忽略类型
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="tx-center">
                <el-checkbox v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                <el-checkbox-group v-model="checkboxGroup1" @change="handle" style="max-height: 300px; overflow: auto">
                  <div class="mt10" v-for="(item, key) in $map.bjStatus">
                    <el-checkbox :label="key" :key="item">{{ item }}</el-checkbox>
                  </div>
                </el-checkbox-group>
                <!-- <el-dropdown-item
                             :command="key"
                             v-for="(item,key) in $map.bjStatus"
                            >{{item}} </el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="btn" @click="$store.commit('swtichLoop')">
            <span style="display: inline-block; width: 80px">{{ isLoop ? '长鸣' : '只响一次' }}</span>
          </div>
          <span :class="`icon-tr-${isMute ? 'mute' : 'voice'} ml20`" @click="$store.commit('switchMute')"></span>
          <span class="icon-tr-Close ml20" @click="showbjList = false"></span>
        </div>
      </div>
      <div style="overflow: auto; height: 300px">
        <table class="hj-message-table" style="width: 100%">
          <thead>
            <tr>
              <!-- <th>处理</th> -->
              <th style="width: 15%">单位名称</th>
              <th style="width: 10%">报警时间</th>
              <!--                        <th>测试</th>-->
              <th style="width: 9%">处理时间</th>

              <th style="width: 5%">报警类型</th>
              <th style="width: 13%">联系电话</th>
              <!--                        <th>节点</th>-->
              <th style="width: 5%">设备类型</th>
              <th style="width: 5%">设备状态</th>

              <th style="width: 12%">报警节点</th>
              <th style="width: 15%">报警地点</th>
              <!-- <th style="width:5%">报警点位</th> -->
              <th style="width: 15%">备注</th>

              <th style="width: 12%">操作</th>
            </tr>
          </thead>
          <tbody class="tr_context_box">
            <tr :class="(item.isLate > 20 || !item.dispose_time) && item.police == 1 && signaltype.indexOf(item.evenClass) > -1 ? 'mark' : ''" v-for="(item, index) in bjList">
              <!-- <td>
                            <a v-if="item.dosomthing==0" title="点击处理" class="blue cursor" @click="handleById(item._id,item)">未处理</a>
                            <span v-else>已处理</span>
                        </td> -->
              <td :title="item.company">{{ item.company }}</td>
              <td :title="item.nowtime">{{ item.nowtime | delYear }}</td>
              <!--                        <td>{{item.test?'是':'否'}}</td>-->
              <td :title="item.company">
                {{ item.dispose_time || '未处理' | delYear }}
              </td>

              <td>{{ item.evenClass }}</td>
              <td :title="item.phone">{{ item.phone }}</td>
              <!--                        <td>x</td>-->

              <td>{{ item.deviceType }}</td>
              <td>{{ item.police == 1 ? '监控' : '测试' }}</td>

              <td :title="item.detailAddr">{{ item.detailAddr }}</td>
              <td :title="item.msgDescribe">{{ item.msgDescribe }}</td>

              <td :title="item.remark">{{ item.remark || '无' }}</td>

              <td>
                <a title="查看点位" class="cursor" @click="openPoint(item)" style="color: #4A9DFF">查看点位</a>
                <a v-if="item.deviceType == '无线烟感'" title="消音" class="cursor ml10" @click="muted(item)" style="color: #4A9DFF">消音</a>

                <a title="处理" class="cursor ml10" @click="detail(item)" style="color: #4A9DFF" v-if="!item.dispose_time">处理</a>

                <a title="处理" class="cursor ml10" style="color: #4A9DFF" v-else-if="item.dispose_time">已处理</a>

                <!-- <span v-else style="color: green">已处理</span> -->
                <!--                            {{item.dosomthing==0?'未处理':'已处理'}}-->
              </td>
            </tr>
          </tbody>
        </table>
        <p class="mt20 tx-center" v-show="bjList.length == 0">没有更多</p>
      </div>
    </el-dialog>

    <!-- 接警用户实时列表 -->
    <el-dialog title="查看设备详情" :visible.sync="deviceShow">
      <div class="flex">
        <facility ref="deviceWS" v-if="deviceShow" />
      </div>
    </el-dialog>

    <el-dialog title="查看点位信息" width="80%" :visible.sync="crtpoint">
      <div class="btn" @click="closeAlarm()" style="position: absolute; top: 5px; right: 300px" v-if="isWaring">
        <span>关闭此次警报</span>
      </div>
      <crtmark :compnum="crtcompany" ref="crtmark"></crtmark>
    </el-dialog>
    <audio src="@/assets/audio/warning.mp3" ref="mp3" id="warningMp3" muted autoplay :loop="isLoop"></audio>
    <message v-if="$store.state.user.userInfo.natureId == 2" :type="1" ref="message" />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import config from '../utils/config.js';
import { getWeihu } from '../api/common.js';
import crtmark from '@/components/crtpoints.vue';
import message from '@/components/message.vue';
import facility from '@/components/homeFacility.vue';
// import {tab5} from '../views/facility/tab5.vue'

if (process.env.NODE_ENV == 'development') {
  //本地
  var wsUrl = config.wsUrltest;
} else if (process.env.NODE_ENV == 'production') {
  //线上
  var wsUrl = config.wsUrl;
}

export default {
  components: { crtmark, message, facility },
  computed: {
    ...mapState(['isMute', 'isWaring', 'isLoop', 'bjList', 'bimStaus', 'compList', 'showbjmode', 'userInfo', 'user']),
  },
  filters: {
    capitalize: function(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    delYear(str) {
      if (str) {
        return str.substring(str.indexOf('年') + 1, str.length);
      }
    },
  },
  data() {
    return {
      info: {}, //警报详情
      signaltype: ['火警', '手动报警', '超限', '漏电'],
      evenClass: 'all',
      checkboxGroup1: this.$local.get('bjstate') || Object.keys(this.$map.bjStatus),
      userId: this.$store.state.user.company.cCompanyNum || '',
      ws: null,
      crtpoint: false,
      crtcompany: {}, //选中的crt点位公司
      heartCheck: null,
      showbjList: false || this.$store.state.showbjmode,
      checkAll: false,
      otherpagefire: false,
      weihuconfirm: false,
      deviceShow: false,
      noPolice: this.$store.state.noPolice || [],
    };
  },

  watch: {
    // deviceShow(v){
    //   if(!v){
    //     this.$refs.deviceWS.distory()
    //   }
    // },
    crtpoint(val) {
      if (!val) {
        this.$refs['crtmark'].reset();
      }
    },
    'user.userInfo': {
      handler(val, oldVal) {
        if (val) {
          if (!(val.natureId == 4)) {
            this.$get('/things/frontPage/innet').then((res) => {
              if (!this.$store.state.compList.length) {
                this.$store.commit('SAVECOMP', res.data);
                // console.log(res.data);
              }
            });
          } else {
            this.$post('/user/areabase', { page: 1, c_name: '', starttime: '', endtime: '', c_belong_profession: '' })
              .then((res) => {
                // console.log(res)
                if (!this.$store.state.compList.length) {
                  this.$store.commit('SAVECOMP', res.list);
                }
              })
              .catch((err) => {});
          }
        }
      },
      immediate: true,
    },
    showbjList(val) {
      if (!val && this.checkboxGroup1.length) {
        this.$local.save('bjstate', this.checkboxGroup1);
      } else if (!this.checkboxGroup1.length) {
        this.$local.remove('bjstate');
      }
      if (!val) {
        this.$store.commit('SHOWBJlIST', val);
      }
    },
    showbjmode(val) {
      this.showbjList = val;
    },
    otherpagefire(val) {
      // console.log(val, 'get state val alarm');
      if (val) {
        this.$confirm('收到新的火警，是否查看', '提示', {
          confirmButtonText: '查看',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal: false,
        })
          .then(() => {
            this.$router.push('/');
            this.otherpagefire = false;
          })
          .catch(() => {
            this.otherpagefire = false;
          });
      }
    },
  },
  mounted() {
    this.handle(this.checkboxGroup1);
    this.$refs.mp3.muted = true;
    var lockReconnect = false; //避免重复连接
    var me = this;
    var ws;
    createWebSocket(); // 创建websocket

    function createWebSocket() {
      try {
        me.ws = new WebSocket(wsUrl);
        websocketInit();
      } catch (e) {
        // log("catch");
        websocketReconnect(wsUrl);
      }
    }

    function websocketInit() {
      // 建立 web socket 连接成功触发事件
      me.ws.onopen = function(evt) {
        onOpen(evt);
      };
      // 断开 web socket 连接成功触发事件
      me.ws.onclose = function(evt) {
        websocketReconnect(wsUrl);
        onClose(evt);
      };
      // 接收服务端数据时触发事件
      me.ws.onmessage = function(evt) {
        onMessage(evt);
      };
      // 通信发生错误时触发
      me.ws.onerror = function(evt) {
        websocketReconnect(wsUrl);
        onError(evt);
      };
    }

    function onOpen(evt) {
      log('建立链接');
      //心跳检测重置
      if (!me.heartCheck.isStart) {
        me.heartCheck.start();
      }
    }

    function onClose(evt) {}

    function onMessage(evt) {
      // console.log(evt)
      if (evt.data === '"shoudao"') {
      } else {
        //！！这里接受消息 写东西
        var data = JSON.parse(evt.data);
        if (data[0].pic_data) delete data[0].pic_data;

        if (data[0].stopdetailaddr && data[0].stopdetailaddr === '1') {
          return false;
        }

        //如果是文物单位
        // if (me.$store.state.userInfo.username.indexOf("文物") > -1) {
        //   return false;
        // }

        //如果是 接网单位
        // var area = me.$store.state.userInfo.area;

        // console.log(data)

        if (me.compList.length) {
          for (var k = 0; k < me.compList.length; k++) {
            if (me.compList[k].c_company_num === (data[0].c_company_num ? data[0].c_company_num : data[0].c_number)) {
              // console.log("匹配成功");
              if (data[0].wsType) {
                // 不走火警的推送
                me.$store.commit('otherWarning', data[0]);
                return;
              }
              if (me.$store.state.user.userInfo.natureId == 4) {
                if (data[0].DType == 199) {
                  me.getJJmeaage(data);
                }
                return false;
              }

              var arr = me.checkboxGroup1;
              if (arr.length) {
                var a = true;
                for (var i = 0; i < arr.length; i++) {
                  var type = me.$map.bjStatus[arr[i]];
                  if (type == data[0].evenClass || !data[0].evenClass) {
                    a = false;
                    break;
                  }
                  if (type == '其他') {
                    if (Object.values(me.$map.bjStatus).indexOf(data[0].evenClass) == -1) {
                      a = false;
                      break;
                    }
                  }
                }
                a ? me.getMessage(data) : '';
              } else {
                me.getMessage(data);
              }
              break;
            } else {
              // console.log('不匹配')
            }
          }

          return;
        } else {
          console.log('查不到公司');
          return;
        }
      }
      //拿到任何消息都说明当前连接是正常的
      me.heartCheck.start();
    }

    function websocketReconnect(url) {
      if (lockReconnect) {
        // 是否已经执行重连
        return;
      }
      lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      tt && clearTimeout(tt);
      var tt = setTimeout(function() {
        createWebSocket(url);
        lockReconnect = false;
      }, 5000);
    }

    //心跳检测
    me.heartCheck = {
      timeout: 5000,
      timeoutObj: null,
      serverTimeoutObj: null,
      isStart: false,
      start: function() {
        var self = this;
        this.isStart = true;
        this.timeoutObj && clearTimeout(this.timeoutObj);
        this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
        this.timeoutObj = setTimeout(function() {
          //发送测试信息，后端收到后，返回一个消息，
          me.ws.send('fasong');
          self.serverTimeoutObj = setTimeout(function() {
            me.ws.close();
          }, self.timeout);
        }, this.timeout);
      },
    };

    function onError(evt) {
      // log("通信错误：" + evt.data);
    }
    // console.log(document.deviceWS )

    /*document.addEventListener('click', () => {
            me.$refs.mp3.play()
        });*/
    this.drag();
  },
  beforeDestroy() {
    //销毁时清除心跳和websoket
    log(this.heartCheck);
    clearTimeout(this.heartCheck.timeoutObj);
    clearTimeout(this.heartCheck.serverTimeoutObj);
    this.ws.close();
    window.location.reload();
  },

  // beforeCreate(){
  //   console.log(this.bjList)
  // },

  created() {
    //  window.event.returnValue=f  alse;
    this.checkboxGroup1.map((item, index) => {
      if (item == 'fire' || item == 'on' || item == 'handfire' || item == 'other') {
        this.checkboxGroup1.splice(index, 1);
      }
    });
    //     setTimeout(() => {
    //         var item = {address: "862675059821526",
    // addressName: "演示单位无线烟感",
    // c_company_num: "ee7a45afdd0540d59efc25eb7f3bde74",
    // c_in_net: "",
    // c_number: "SDQDSB000085",
    // c_type: "2",
    // company: "演示单位无线烟感",
    // dType: "2",
    // detailAddr: "技术部测试三江",
    // deviceType: "通用",
    // dosomthing: "0",
    // down: "",
    // evenClass: "火警",
    // id: "66a18ee8-95e8-4c3b-a2eb-449ede2a042c",
    // innet: "",
    // isbim: "0",
    // lat: "36.111045",
    // lon: "120.413937",
    // monitor: "",
    // msgDescribe: "测试烟感",
    // nowtime: "2022年02月17日 08:17:44",
    // phone: "66002028/66002015",
    // police: "1",
    // remark: "火警1分钟后电话确认",
    // starttime: "",
    // status: "1",
    // stopdetailaddr: "0",
    // test: "",
    // _id:""}
    //         console.log(item)
    //       var it = {...item,...{"dosomthing":"0","address":"8677250332429611","flag":"0","c_company_num":"e3bc2fd41bf74ee5ba56f9e4f0d88ad3","evenClass":"超限","sendtype":"2","detailAddr":"顶层消防水箱（一期）","overflow":"正常","dType":3,"nowtime":"2022年02月15日 00:45:10","time":1644857107000,"_id":{"counter":9833508,"date":1644857110000,"machineIdentifier":6577985,"processIdentifier":19851,"time":1644857110000,"timeSecond":1644857110,"timestamp":1644857110},"msgDescribe":"99:信号正常","value":"1.7625"}}
    //       // var it = item
    //      console.log(it)
    //      this.getMessage([it])
    //     },10000);
    // console.log(this.bjList);
  },
  methods: {
    deviceDetail() {
      this.deviceShow = true;
    },
    //消音
    muted(it) {
      this.$post('/wuxian/xiaoyin', { ci_num: it.address }).then((res) => {

        this.$message({
                message: '操作成功',
                type: 'success',
                duration: 700,
              });
      });
    },
    setMessage() {
      this.$refs['message'].showDia1 = true;
    },
    changeTime(timeNow, timeBefore) {
      var _this = this;

      function changeStr(str) {
        // var str = _this.$local.get('nowtime')
        str = str.replace(/年/g, '/');
        str = str.replace(/月/g, '/');
        str = str.replace(/日/g, '');
        return str;
      }

      let timeLine = new Date(changeStr(timeNow)).getTime();
      let timeline = new Date(changeStr(timeBefore)).getTime();

      return (timeLine - timeline) / 1000 / 60;
    },

    // 处理接警单位数据

    detail(it) {
      console.log('zouyi',it);
      this.$emit('detail', it);
      this.$store.commit('DETAILALRAM', it);
    },
    getJJmeaage(data) {
      // 存到本地接警单位
      if (data[0].c_number) {
        this.info = data[0];
        this.startWarning(data[0]);
      }
      //    var addWarning = () => {
      //   // if (
      //   //   data[0].police == 0 &&
      //   //   this.$store.state.user.company.cCompanyNum === "aaa"
      //   // ) {
      //   //   //测试
      //   //   return;
      //   // }
      // };
    },
    openPoint(it, alarm) {
      // if (alarm) {
      //   console.log("收到报警 展示crt");
      // }
      var obj = { c_number: it.c_company_num, number: it.detailAddr || '' };
      this.$post('crt/crtselect', obj).then((res) => {
        if (!(res.data.length && res.data[0].area_uuid)) {
          // alert('无')
          // this.$message.warning("该区域无点位标注，请联系管理员");
          return;
        }
        this.crtcompany = obj;
        this.crtpoint = true;
        // data[0]:报警的点位图及点位，闪动的点位
        //  data[1]:闪动的摄像头信息
        // data[2]:该点位图下绑定的其他点位位置
      });
    },
    drag(e) {
      var oDiv = this.$refs.alarm;
      document.oncontextmenu = function() {
        return false;
      };
      // console.log(e.clientX)
      oDiv.onmousedown = function(e) {
        if (e.button !== 0) {
          var left = e.clientX - oDiv.offsetLeft;
          var top = e.clientY - oDiv.offsetTop;

          document.body.onmousemove = function(e) {
            var NowLeft = e.clientX - left;
            var NowTop = e.clientY - top;
            if (NowLeft < 0) {
              NowLeft = 0;
            }
            if (NowTop < 0) {
              NowTop = 0;
            }

            oDiv.style.top = NowTop + 'px';
            oDiv.style.left = NowLeft + 'px';
          };
          document.body.onmouseup = function() {
            document.body.onmousemove = null;
            document.body.onmouseup = null;
          };
        }
      };

      //    oDiv.style.left = e.clientX-oDiv.offsetLeft + 'px'
    },
    //全选
    handleCheckAllChange(val) {
      this.checkboxGroup1 = val ? Object.keys(this.$map.bjStatus) : [];
    },

    handle(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === Object.keys(this.$map.bjStatus).length;
    },
    closeAlarm() {
      // this.closeBim();
      //处理停止报警业务
      this.$store.commit('swithWaring', 0);
    },

    // closeBim(warning) {
    //   // console.log('请求bim')
    //   var it = this.info;
    //   if (it.isbim && it.isbim == 1) {
    //     var detailAddr = it.detailAddr;
    //     var action = warning ? 1 : 5;
    //     this.$get("/terminal/fireAlarmControl", {
    //       address: "",
    //       detailAddr,
    //       action,
    //     });
    //   }
    // },
    bimchange(it) {
      //展示bim，请求bim接口
      // console.log(it)

      // this.$post('',)
      this.$store.commit('bimchange', 'https://www.qutgroup.com/fcweb/demo');
    },
    showFire() {
      if (this.$store.state.user.userInfo.natureId == 4) {
        if (this.isWaring) {
          this.closeAlarm();
        }
        return;
      }
      this.showbjList = true;
    },
    getMessage(data) {
      // console.log('增加火警')
      if (data[0].c_company_num) {
        this.$store.commit('addBjList', data[0]);
      }
      var addWarning = () => {
        this.info = data[0];

        if (data[0].police == 0 || data[0].evenClass == '复位') {
          //测试
          return;
        }
        if (this.noPolice.indexOf(this.$store.state.user.company.cCompanyNum) > -1) {
          return;
        }
        this.startWarning(data[0]);
      };
      if (data && data[0]) {
        if (data[0].c_company_num) {
          var num = data[0].c_company_num;
          this.compList.map((item, index) => {
            if (item.c_company_num === num) {
              addWarning(data[0]);
              return;
            }
          });
          // this.$post('/demarcate/allcompanyshowsfire').then(res=>{
          //     res.data.company.map((item,index)=>{
          //         if(item.c_company_num===num){
          //              addWarning(data[0])
          //              return
          //         }
          //     })

          // })
        } else {
          //   console.log('无字段或为空')
          //   addWarning(data[0])
        }
      }
    },
    startWarning() {
      //开始警报
      // if (!this.weihuconfirm) {
      //   getWeihu().then((res) => {
      //     this.$store.commit("isWeihu", res.data);
      //     var ob = this.$store.state.weihutime;
      //     if (ob.endtime && ob.starttime) {
      //       this.$alert(
      //         `尊敬的客户,我们将于 ${ob.starttime} 至 ${ob.endtime} 进行系统升级维护，维护期间系统暂时无法登入，给您造成不便，敬请谅解。`,
      //         "公告",
      //         {
      //           confirmButtonText: "确定",
      //           callback: (action) => {
      //             this.weihuconfirm = true;
      //           },
      //         }
      //       );
      //     }
      //   });
      // }
      var it = this.info;
      // this.closeBim(true);
      //告知bim响火警
      // console.log('baojing')
      this.$store.commit('swithWaring', true);

      //   if(it.evenClass=='火警'){
      //  this.openPoint(it)

      // }
      if (!this.isMute) {
        this.$refs.mp3.currentTime = 0;
        this.$refs.mp3.volume = 1; //声音大小
        this.$refs.mp3.muted = false;
        // let mp3 = document.getElementById('warningMp3')
        // mp3.play()

        this.$refs.mp3.play();
      }
      if ((this.userId || !(this.$local.get('userInfo').natureId == 2)) && this.$route.path !== '/' && it.evenClass === '火警') {
        this.otherpagefire = true;
      }
      if (this.$store.state.user.userInfo.natureId == 2 && !this.$store.state.user.isWenwu) {
        // alert(it)
        this.openPoint(it, true);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.alarm {
  position: absolute;
  top: 64px;
  left: 20px;
  z-index: 99999;
}
.warAlarm {
  left: 0.5%;
  overflow: auto;
  width: 20%;
  min-width: 320px;
  box-sizing: border-box;
  z-index: 77;
}
.bim {
  color: blue;
  text-decoration: underline;
  margin-left: 5px;
  cursor: pointer;
  animation: bimmove 1s ease infinite;
}
.mark > td {
  color: red;
  font-weight: 500;
  // background: rgba(255,0,0,.4);
}
@keyframes bimmove {
  from {
    color: blue;
  }
  to {
    color: red;
  }
}
.hg-notice-icon {
  .icon-cont {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    font-size: 14px;
    height: 20px;
    background: #fff;
    border-radius: 50%;
  }
}
.hg-notice-new {
  opacity: 0.9;
  padding-bottom: 5px;
  overflow: auto;
  left: 5px;
  top: 70px;
  width: 100%;
  height: 7vw;
  opacity: 1;
  border-radius: 8px;
  background: linear-gradient(180deg, rgba(255, 146, 45, 0.7) 0%, rgba(255, 45, 46, 0.7) 100%), url(https://img.js.design/assets/img/6268d2d323680b9d09d0c60b.png);
  // background-image:;

  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
}
.hj-notice-msg img {
  height: 80px;
}
.hg-notice-cont {
  box-sizing: border-box;
}
.hg-notice-item {
  font-size: 14px;
  color: #fff;
  font-weight: 400;
  letter-spacing: 0px;
  text-align: left;
  vertical-align: middle;
}
// .hj-notice-f {
//   background: url("~@/assets/img/Popup2.png");
//   background-size: 100% 100%;
//   color: #333;
//   position: absolute;
//   bottom: 7px;
//   left: 68px;
//   width: 240px;
//   height: 65px;
//   padding-left: 20px;
//   padding-top: 5px;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   white-space: nowrap;
//   font-weight: 600;
// }

// .hj-notice-f12 {
//   padding-left: 10px;
// }

// .hj-notice-f div {
//   overflow: hidden;
//   text-overflow: ellipsis;
//   white-space: nowrap;
// }

// .hj-notice-f1 {
//   font-size: 12px;
// }

// .hj-notice-f2,
// .hj-notice-f3 {
//   font-size: 14px;
// }

#warningMp3 {
  display: none;
}

.bj-wrap > div {
  position: fixed;
  z-index: 99999;
}

.bj-wrap .bj-wrap-top {
  height: 100px;
  left: 0;
  right: 0;
  top: 0;
  background: linear-gradient(#c00, rgba(255, 255, 255, 0));
  animation: topAn 0.6s infinite alternate;
}

.bj-wrap .bj-wrap-left {
  width: 100px;
  left: 0;
  bottom: 0;
  top: 0;
  background: linear-gradient(to right, #c00, rgba(255, 255, 255, 0));
  animation: leftAn 0.6s infinite alternate;
}

.bj-wrap .bj-wrap-right {
  width: 100px;
  bottom: 0;
  right: 0;
  top: 0;
  background: linear-gradient(to left, #c00, rgba(255, 255, 255, 0));
  animation: rightAn 0.6s infinite alternate;
}

.bj-wrap .bj-wrap-bottom {
  height: 100px;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(rgba(255, 255, 255, 0), #c00);
  animation: bottomAn 0.6s infinite alternate;
}

@keyframes topAn {
  from {
    top: 0;
  }

  to {
    top: -100px;
  }
}

@keyframes bottomAn {
  from {
    bottom: 0;
  }

  to {
    bottom: -100px;
  }
}

@keyframes leftAn {
  from {
    left: 0;
  }

  to {
    left: -100px;
  }
}

@keyframes rightAn {
  from {
    right: 0;
  }

  to {
    right: -100px;
  }
}
</style>
